import {
  selectMappedArea,
  selectMappedAreas,
  selectMappedAreaLoading,
  selectMappedAreasLoading,
  selectMappedAreaError,
} from '../core/reducers/mapped-area.reducer';

export const getMappedArea = selectMappedArea;
export const getMappedAreas = selectMappedAreas;
export const getMappedAreaLoading = selectMappedAreaLoading;
export const getMappedAreasLoading = selectMappedAreasLoading;
export const getMappedAreaError = selectMappedAreaError;
